import type { ReactNode } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import MobileBottomNav from '@/components/feature/MobileBottomNav';

interface SiteLayoutProps {
  children: ReactNode;
}

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <div className="h-16 md:hidden" aria-hidden="true" />
      <MobileBottomNav />
    </div>
  );
}